if ($(".type-detail").length) {
  if ($(".p-detail-info .flag-vahova-polozka").length) {
    $('.p-info-wrapper .price-measure').after('<span class="info">Výsledná hmotnost a cena se mohou po vyskladnění mírně lišit</span>');
  }

  const $pInfoWrapper = $(".p-info-wrapper");
  const $featureRow = $(".detail-parameters tr").filter(function () {
    return $(this).find("th .row-header-label").text().trim().replace(/:$/, "") === "Vlastnosti";
  }).first();

  if ($pInfoWrapper.length && $featureRow.length && !$pInfoWrapper.find(".features").length) {
    const featureValues = $featureRow.find("td").text().trim().replace(/\s+/g, " ").split(",")
      .map(function (value) { return value.trim(); })
      .filter(Boolean);

    if (featureValues.length) {
      const $features = $('<div class="features"></div>');
      featureValues.forEach(function (value) {
        $features.append($('<span class="feature"></span>').text(value));
      });
      $pInfoWrapper.append($features);
    }
  }
  if ($('body.velkoobchod').length) {
    $('.p-final-price-wrapper').addClass("velkoobchod");

  }
}
